<template>
  <svg :width="width" :height="height" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M36.2623 52.9256C34.9712 53.1913 34 54.3403 34 55.7173V59.0699C34 60.6437 35.2685 61.9195 36.8333 61.9195H40.1667C41.7315 61.9195 43 60.6437 43 59.0699V55.7173C43 54.1435 41.7315 52.8677 40.1667 52.8677H36.8333C36.6377 52.8677 36.4468 52.8876 36.2623 52.9256ZM41 55.7173C41 55.2545 40.6269 54.8792 40.1667 54.8792H36.8333C36.7758 54.8792 36.7196 54.8851 36.6654 54.8962C36.2857 54.9744 36 55.3123 36 55.7173V59.0699C36 59.5327 36.3731 59.908 36.8333 59.908H40.1667C40.6269 59.908 41 59.5327 41 59.0699V55.7173Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17 55.7173C17 54.1435 18.2685 52.8677 19.8333 52.8677H23.1667C24.7315 52.8677 26 54.1435 26 55.7173V59.0699C26 60.6437 24.7315 61.9195 23.1667 61.9195H19.8333C18.2685 61.9195 17 60.6437 17 59.0699V55.7173ZM19.8333 54.8792H23.1667C23.6269 54.8792 24 55.2545 24 55.7173V59.0699C24 59.5327 23.6269 59.908 23.1667 59.908H19.8333C19.3731 59.908 19 59.5327 19 59.0699V55.7173C19 55.2545 19.3731 54.8792 19.8333 54.8792Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M51 29.5678C51 27.994 52.2685 26.7182 53.8333 26.7182H57.1667C58.7315 26.7182 60 27.994 60 29.5678V32.9203C60 34.4941 58.7315 35.7699 57.1667 35.7699H53.8333C52.2685 35.7699 51 34.4941 51 32.9203V29.5678ZM53 29.5678C53 29.1049 53.3731 28.7297 53.8333 28.7297H57.1667C57.6269 28.7297 58 29.1049 58 29.5678V32.9203C58 33.3832 57.6269 33.7584 57.1667 33.7584H53.8333C53.3731 33.7584 53 33.3832 53 32.9203V29.5678Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M36.2623 26.776C34.9712 27.0418 34 28.1907 34 29.5678V32.9203C34 34.4941 35.2685 35.7699 36.8333 35.7699H40.1667C41.7315 35.7699 43 34.4941 43 32.9203V29.5678C43 27.994 41.7315 26.7182 40.1667 26.7182H36.8333C36.6377 26.7182 36.4468 26.7381 36.2623 26.776ZM41 29.5678C41 29.1049 40.6269 28.7297 40.1667 28.7297H36.8333C36.7758 28.7297 36.7196 28.7355 36.6654 28.7467C36.2857 28.8248 36 29.1628 36 29.5678V32.9203C36 33.3832 36.3731 33.7584 36.8333 33.7584H40.1667C40.6269 33.7584 41 33.3832 41 32.9203V29.5678Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17 29.5678C17 27.994 18.2685 26.7182 19.8333 26.7182H23.1667C24.7315 26.7182 26 27.994 26 29.5678V32.9203C26 34.4941 24.7315 35.7699 23.1667 35.7699H19.8333C19.6377 35.7699 19.4468 35.75 19.2623 35.712C17.9712 35.4463 17 34.2974 17 32.9203V29.5678ZM19 29.5678C19 29.1049 19.3731 28.7297 19.8333 28.7297H23.1667C23.6269 28.7297 24 29.1049 24 29.5678V32.9203C24 33.3832 23.6269 33.7584 23.1667 33.7584H19.8333C19.7758 33.7584 19.7196 33.7526 19.6654 33.7414C19.2857 33.6632 19 33.3253 19 32.9203V29.5678Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M60 55.7173C60 54.1435 58.7315 52.8677 57.1667 52.8677H53.8333C52.2685 52.8677 51 54.1435 51 55.7173V59.0699C51 60.6437 52.2685 61.9195 53.8333 61.9195H57.1667C58.7315 61.9195 60 60.6437 60 59.0699V55.7173ZM57.1667 54.8792H53.8333C53.3731 54.8792 53 55.2545 53 55.7173V59.0699C53 59.5327 53.3731 59.908 53.8333 59.908H57.1667C57.6269 59.908 58 59.5327 58 59.0699V55.7173C58 55.2545 57.6269 54.8792 57.1667 54.8792Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M55.167 6.60311V4H53V6.60311H24V4H21.833V6.60311H11.9945C8.13154 6.60311 5 9.75267 5 13.6378V65.948C5 69.8332 8.13154 72.9827 11.9945 72.9827H65.0055C68.8685 72.9827 72 69.8332 72 65.948V13.6378C72 9.75267 68.8685 6.60311 65.0055 6.60311H55.167ZM65.0055 70.9712C67.7639 70.9712 70 68.7223 70 65.948V21.6894H7V65.948C7 68.7223 9.23611 70.9712 11.9945 70.9712H65.0055ZM21.833 8.61462H11.9945C9.23611 8.61462 7 10.8636 7 13.6378V17.6664H70V13.6378C70 10.8636 67.7639 8.61462 65.0055 8.61462H55.167V13H55V13.0518H53V8.61462H24V13.0518H22V13H21.833V8.61462Z"
      fill="#05070F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M34 42.6425C34 41.0687 35.2685 39.7929 36.8333 39.7929H40.1667C41.7315 39.7929 43 41.0687 43 42.6425V45.995C43 47.5689 41.7315 48.8447 40.1667 48.8447H36.8333C36.6377 48.8447 36.4468 48.8247 36.2623 48.7868C34.9712 48.5211 34 47.3721 34 45.995V42.6425ZM36 42.6425C36 42.1796 36.3731 41.8044 36.8333 41.8044H40.1667C40.6269 41.8044 41 42.1796 41 42.6425V45.995C41 46.4579 40.6269 46.8332 40.1667 46.8332H36.8333C36.7758 46.8332 36.7196 46.8273 36.6654 46.8161C36.2857 46.738 36 46.4001 36 45.995V42.6425Z"
      fill="#FF0064"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M53.8333 39.7929C52.2685 39.7929 51 41.0687 51 42.6425V45.995C51 47.5689 52.2685 48.8447 53.8333 48.8447H57.1667C58.7315 48.8447 60 47.5689 60 45.995V42.6425C60 41.0687 58.7315 39.7929 57.1667 39.7929H53.8333ZM58 42.6425C58 42.1796 57.6269 41.8044 57.1667 41.8044H53.8333C53.3731 41.8044 53 42.1796 53 42.6425V45.995C53 46.4579 53.3731 46.8332 53.8333 46.8332H57.1667C57.6269 46.8332 58 46.4579 58 45.995V42.6425Z"
      fill="#FF0064"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.2623 39.8508C17.9712 40.1165 17 41.2655 17 42.6425V45.995C17 47.5689 18.2685 48.8447 19.8333 48.8447H23.1667C24.7315 48.8447 26 47.5689 26 45.995V42.6425C26 41.0687 24.7315 39.7929 23.1667 39.7929H19.8333C19.6377 39.7929 19.4468 39.8128 19.2623 39.8508ZM24 42.6425C24 42.1796 23.6269 41.8044 23.1667 41.8044H19.8333C19.7758 41.8044 19.7196 41.8103 19.6654 41.8214C19.2857 41.8996 19 42.2375 19 42.6425V45.995C19 46.4579 19.3731 46.8332 19.8333 46.8332H23.1667C23.6269 46.8332 24 46.4579 24 45.995V42.6425Z"
      fill="#FF0064"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'CalendarEmptyIllustration',
  props: {
    width: {
      type: Number,
      default: 76,
    },
    height: {
      type: Number,
      default: 76,
    },
  },
};
</script>
